import './index.less'

export default () => {
    if (!customElements.get('jky-nav')) {
        customElements.define('jky-nav', class JkyNav extends HTMLElement {
            constructor() {
                super();
                this.scrolling = false
                this.setTabsUnderline()
                this.init()
            }
            connectedCallback() {
                // 监听 hash 变化
                window.addEventListener('hashchange', () => this.handleHashChange());

                // 初始化逻辑：直接调用 + 兼容 DOM 未加载完成的情况
                // 如果需要确保 DOM 完全加载后再进行操作，可以使用 setTimeout 或者监听 DOMContentLoaded 事件
                // if (document.readyState === 'loading') {
                //     document.addEventListener('DOMContentLoaded', () => this.handleHashChange());
                // } else {
                //     this.handleHashChange()
                // }
                // 确保页面完全加载后再调用，以防有延迟加载的内容
                window.addEventListener('load', () => this.handleHashChange())
            }
            handleHashChange() {
                const hash = window.location.hash.substring(1);
                // 强校验：排除空值、纯空格、特殊符号开头的非法值
                if (!hash) return;

                const selector = `.jky-nav-item[target="${hash}"]`;
                const targetElement = document.querySelector(selector);

                if (targetElement) {
                    // 使用原生方法触发点击事件
                    targetElement.click();
                } else {
                    console.warn(`No element found with target="${hash}"`);
                }
            }
            init() {
                const that = this
                $(this).find(".jky-nav-item").click(function (e) {
                    if (that.scrolling) return
                    that.scrolling = true

                    const next = that.getActiveIndex() < $(this).index()
                    const target = $(this).attr("target")
                    const anchor = $(`[anchor=${target}]`)
                    $(that).find(".jky-nav-item").removeClass("active")
                    $(this).addClass("active")
                    that.setTabsUnderline()
                    if (!anchor.length) return
                    that.scrollToAnchor(anchor, next, e.isTrigger)
                })

                this.invertNavigation()
            }
            setTabsUnderline() {
                const tabs_under_line = $(this).find(".jky-nav-slideline--inner")
                const active_tab = $(this).find(".jky-nav-item.active")
                if (!tabs_under_line.length || !active_tab.length) return
                tabs_under_line.width(`${active_tab.width()}px`)
                tabs_under_line.css("left", `${active_tab.position().left}px`)
            }

            scrollToAnchor(target, next = true, trigger = false) {
                const anchor = target.attr("anchor")
                const that = this

                if (!this.isElementFullyInsideContainer($(this).find(`[target=${anchor}]`)[0], this.querySelector(".jky-nav-inner"))) {
                    this.scrollToElement($(this).find(`[target=${anchor}]`), next)
                }

                if(!trigger) {
                    $('html, body').animate({
                        scrollTop: $(target).offset().top
                    }, 200, function () {
                        that.scrolling = false
                    });
                } else {
                    that.scrolling = false
                }
            }
            scrollToElement(element, next) {
                var container = $(this).find(".jky-nav-inner")
                var elementRect = element[0].getBoundingClientRect();
                var parentRect = container[0].getBoundingClientRect();

                var scrollLeft = next ? container.scrollLeft() - parentRect.right + elementRect.right : container.scrollLeft() + elementRect.x - parentRect.x
                container.animate({
                    scrollLeft: scrollLeft
                }, 200);
            }
            getActiveAnchor() {
                return $(this).find(".jky-nav-item.active").attr("target")
            }
            getActiveIndex() {
                return $(this).find(".jky-nav-inner--container").children(".jky-nav-item.active").index()
            }
            invertNavigation() {
                const that = this
                const nav = document.querySelector(".product-tabs-box");

                function didChangeViewport() {
                    const doc = document
                    const elements = Array.from(doc.querySelectorAll("[anchor]"));
                    const isMobile = window.innerWidth < 1024;

                    const slide = elements.find((element) => {
                        const MARGIN = isMobile ? 45.0 : 65.0;
                        const { top, bottom } = element.getBoundingClientRect();
                        return top < MARGIN && bottom > MARGIN;
                    });
                    if (slide && !that.scrolling) {
                        if (isMobile && slide.dataset.invertMobile) {
                            const shouldInvertMobile = slide.dataset.invertMobile === "true";
                            nav.classList.toggle("inverted", shouldInvertMobile);
                        } else {
                            if (that.getActiveAnchor() !== $(slide).attr("anchor")) {
                                $(slide).attr("anchor") && $(that).find(`.jky-nav-item[target=${$(slide).attr("anchor")}]`).trigger("click")
                            }
                        }
                    } else {}
                }

                window.addEventListener("scroll", didChangeViewport, {
                    passive: true
                });
                didChangeViewport();

                return function destroyInvertNavigation() {
                    window.removeEventListener("scroll", didChangeViewport);
                };
            }

            isElementFullyInsideContainer(element, container) {
                var elementRect = element.getBoundingClientRect();
                var containerRect = container.getBoundingClientRect();

                return (
                    elementRect.left >= containerRect.left &&
                    elementRect.right <= containerRect.right
                );
            }
        })
    }
}
